import env from "../utils/env";
import { prepareHttpHeaders } from "../utils/http";

export const createPayPalPaymentRequest = async payload => {
  const baseUrl = env("BASE_URL");
  const res = await fetch(`${baseUrl}paypal/payments`, {
    method: "POST",
    headers: prepareHttpHeaders(null, true),
    body: JSON.stringify({
      commit: "Pay",
      payment: {
        ...payload,
        popup: "false",
        mobile: "true",
        digital: "true",
        recurring: "false"
      }
    })
  });

  return res.json();
};

export const cancelPayPalPaymentRequest = orderId => {
  const baseUrl = env("BASE_URL");

  fetch(`${baseUrl}paypal/payments/cancel?token=${orderId}`, {
    method: "GET",
    headers: prepareHttpHeaders(null, true)
  });
};

export const approvePayPalPaymentRequest = (orderId, payerId) => {
  const baseUrl = env("BASE_URL");

  fetch(
    `${baseUrl}paypal/payments/success?token=${orderId}&PayerID=${payerId}`,
    {
      method: "GET",
      headers: prepareHttpHeaders(null, true)
    }
  );
};
